import * as tslib_1 from "tslib";
import { Button, Popover, SvgIcon, Tooltip } from '@nextiva/next-ui';
import * as React from 'react';
import Styles from "./IconDropdown.css";
import OptionsList from './OptionsList';

var IconDropdown =
/** @class */
function (_super) {
  tslib_1.__extends(IconDropdown, _super);

  function IconDropdown() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isOpen: false
    };

    _this.setSelected = function (item) {
      var onChange = _this.props.onChange;

      _this.close();

      onChange(item);
    };

    _this.close = function () {
      _this.setState({
        isOpen: false
      });
    };

    _this.toggleDropdown = function () {
      var isOpen = _this.state.isOpen;

      var isEmpty = _this.isEmpty();

      if (!isEmpty) {
        _this.setState({
          isOpen: !isOpen
        });
      }
    };

    _this.isEmpty = function () {
      var _a = _this.props,
          options = _a.options,
          fixedIcon = _a.fixedIcon;
      return options.length < (Boolean(fixedIcon) ? 1 : 2);
    };

    _this.renderOptions = function () {
      var _a = _this.props,
          options = _a.options,
          value = _a.value,
          getIconSrc = _a.getIconSrc,
          fixedIcon = _a.fixedIcon;
      return React.createElement(OptionsList, {
        onSelect: _this.setSelected,
        options: options,
        getIconSrc: getIconSrc,
        value: value,
        fixedIcon: fixedIcon
      });
    };

    _this.getIcon = function () {
      var _a = _this.props,
          fixedIcon = _a.fixedIcon,
          textIcon = _a.textIcon,
          value = _a.value,
          options = _a.options,
          getIconSrc = _a.getIconSrc;

      if (fixedIcon) {
        return React.createElement(SvgIcon, {
          className: Styles.icon,
          src: fixedIcon
        });
      }

      if (textIcon) {
        return textIcon;
      }

      var iconName = value && value.icon || options[0] && options[0].icon;

      if (iconName && getIconSrc) {
        return React.createElement(SvgIcon, {
          className: Styles.icon,
          src: getIconSrc(iconName)
        });
      }

      if (value && value.label) {
        return React.createElement("span", null, value.label);
      }

      return null;
    };

    return _this;
  }

  IconDropdown.prototype.render = function () {
    var _a = this.props,
        options = _a.options,
        getIconSrc = _a.getIconSrc,
        hideArrow = _a.hideArrow,
        ariaLabel = _a.ariaLabel,
        disabled = _a.disabled,
        disabledText = _a.disabledText;
    var isOpen = this.state.isOpen;
    var isDisabled = this.isEmpty() || disabled;
    var icon = this.getIcon();
    return React.createElement("div", {
      className: Styles.iconDropdown,
      "data-test": this.props['data-test']
    }, isDisabled ? React.createElement(Tooltip, {
      text: disabledText,
      arrow: false,
      dark: true
    }, React.createElement(Button, {
      disabled: true
    }, icon)) : React.createElement(Popover, {
      className: Styles.popover,
      isOpen: isOpen,
      togglePopover: this.toggleDropdown,
      body: this.renderOptions(),
      popper: {
        placement: 'bottom-end',
        modifiers: {
          offset: {
            offset: '0, 5'
          }
        }
      }
    }, React.createElement(Button, {
      "aria-label": ariaLabel
    }, icon, !hideArrow && options.length > 1 && React.createElement(SvgIcon, {
      className: Styles.triangle,
      src: getIconSrc('arrow-down')
    }))));
  };

  IconDropdown.defaultProps = {
    options: [],
    disabled: false,
    onChange: function onChange() {},
    getIconSrc: function getIconSrc() {
      return '';
    }
  };
  return IconDropdown;
}(React.PureComponent);

export default IconDropdown;